// LookingForCards.js
import React from 'react';
import { Card, CardContent, Typography, IconButton, Box } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { imagebuy, imagerent, imagelease, property_pincode_new } from './ImageConstants';

const LookingForCards = ({ navigate }) => {
  const cardStyle = {
    backgroundColor: '#d8ccba',
    borderTopLeftRadius: '24px',
    borderBottomRightRadius: '24px',
    overflow: 'hidden',
    height: 140,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.7)',
    cursor: 'pointer',
    transform: 'perspective(1000px)',
    transition: 'transform 0.4s ease, box-shadow 0.4s ease',
    '&:hover': {
      transform: 'perspective(1000px) scale(1.03) rotateX(2deg)',
      boxShadow: '0 16px 32px rgba(0, 0, 0, 0.45), 0 12px 12px rgba(0, 0, 0, 0.30)',
    },
  };

  const cards = [
    { 
      title: 'Buy', 
      image: imagebuy, 
      onClick: () => navigate('/buy-map', { state: { category: "Painting" } }),
      bgColor: '#d8ccba'
    },
    { 
      title: 'Rent', 
      image: imagerent, 
      onClick: () => navigate('/rent-propertymap', { state: { category: "Electrical" } }),
      bgColor: '#d8ccba'
    },
    { 
      title: 'Lease', 
      image: imagelease, 
      onClick: () => navigate('/lease_map', { state: { category: "Plumbing" } }),
      bgColor: '#d8ccba'
    },
    { 
      title: 'Sell / Post', 
      image: property_pincode_new, 
      onClick: () => navigate('/post', { state: { category: " Tiles & Granite Repair works" } }),
      bgColor: '#d8ccba'
    },
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: 2,
        width: '108%',
        marginLeft: '-4%',
      }}
    >
      {cards.map((card, index) => (
        <Card key={index} onClick={card.onClick} sx={cardStyle}>
          <Box
            sx={{
              height: '65%',
              border: '1px solid black',
              backgroundImage: `url(${card.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderBottomRightRadius: '24px',
              position: 'relative',
              boxShadow: '0 10px 20px rgba(0, 0, 0, 0.35)',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                height: '8px',
                borderBottomRightRadius: '24px',
                zIndex: 2,
              },
            }}
          />
          <CardContent
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '35%',
              px: 1.5,
              py: 0.5,
              backgroundColor: '#d8ccba',
            }}
          >
            <Typography
              variant="body2"
              fontWeight="600"
              color="#333"
              sx={{
                fontSize: '0.88rem',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {card.title}
            </Typography>
            <IconButton sx={{ color: '#333', p: 0.5 }}>
              <ArrowForwardIosIcon fontSize="small" />
            </IconButton>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default LookingForCards;